/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Footer from 'components/Footer'
import StickyNavigation from 'components/StickyNavigation'

import 'styles/main.scss'

const LayoutSEM = ({
  theme,
  children,
  isServicesPage,
  isPortfolioPage,
  isAboutPage,
}) => {
  function renderContent() {
    return (
      <main
        className={cx('sem__main', `--${theme}`, {
          '--services': isServicesPage,
          '--about': isAboutPage,
        })}
      >
        <StickyNavigation theme={theme} />
        {children}
        <Footer
          hasSocial
          theme={theme}
          isServicesPage={isServicesPage}
          isPortfolioPage={isPortfolioPage}
        />
      </main>
    )
  }

  return renderContent()
}

LayoutSEM.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
  location: PropTypes.object,
  isServicesPage: PropTypes.bool,
  isPortfolioPage: PropTypes.bool,
  isAboutPage: PropTypes.bool,
}

export default LayoutSEM
